<template>
  <article class="control-page">
    <div v-if="controlsDisplayed" class="control-panel">
      <form>
        <h4>Advisor Account</h4>
        <div>
          <input type="button" value="New Account" @click="clearAccount">
          <input type="button" value="Reset Basic Account" @click="resetAccount">
        </div>
        <h4>Clients</h4>
        <div>
          <input type="button" value="No clients" @click="clearClients">
          <input type="button" value="Reset clients" @click="resetClients">
        </div>
        <h4>Bank account</h4>
        <div>
          <input type="button" value="Unlink bank account" @click="unlinkBankAccount">
          <input type="button" value="Link bank account" @click="linkBankAccount">
          <input type="button" value="No billings" @click="clearBillings">
          <input type="button" value="Reset billings" @click="resetBillings">
        </div>
      </form>
    </div>
    <button type="button" class="controls-toggle" @click="toggleControls">C</button>
    <dashboard-clients />
    <component :is="modalComponent" v-if="modalDisplay" @close="closeModal" />
  </article>
</template>

<script>
import store from '@/store';
import { profile, profilePayment } from '@/components/advisor';
import { modal } from '@/components/layout';
import dashboardClients from '@/views/app/clients';

export default {
  route: {
    meta: { requiresAuth: true },
  },
  components: {
    dashboardClients, profile, profilePayment, modal,
  },
  data() {
    return {
      controlsDisplayed: true,
      modalDisplay: false,
      modalComponent: '',
    };
  },
  methods: {
    toggleControls() {
      this.controlsDisplayed = !this.controlsDisplayed;
    },
    clearAccount() {
      const account = [];
      account.billings = [];
      account.bank = [];
      account.email = 'mario@oneup.com';
      account.bankAccountLinked = false;
      store.commit('updateAccount', account);
      store.commit('updateAccount', account);
      store.commit('updateClients', []);
    },
    clearClients() {
      store.commit('updateClients', []);
    },
    resetClients() {
      store.dispatch('fetchClients');
    },
    unlinkBankAccount() {
      const account = store.getters.account;
      account.bankAccountLinked = false;
      store.commit('updateAccount', account);
    },
    linkBankAccount() {
      const account = store.getters.account;
      account.bankAccountLinked = true;
      store.commit('updateAccount', account);
    },
    clearBillings() {
      const billing = store.getters.billing;
      billing.billings = [];
      store.commit('updateBilling', billing);
    },
    resetBillings() {
      store.dispatch('fetchBilling');
    },
    resetAccount() {
      store.dispatch('fetchAccount');
      store.dispatch('fetchClients');
      store.dispatch('fetchBilling');
    },
    showModal(comp) {
      this.modalComponent = comp;
      this.modalDisplay = true;
    },
    closeModal() {
      this.modalDisplay = false;
    },
  },
  async beforeRouteEnter(to, from, next) {
    return Promise.all([
      store.dispatch('fetchClients'),
      store.dispatch('fetchAccount'),
      store.dispatch('fetchBilling'),
    ])
      .then(next);
  },
};
</script>
